import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import BajaAltaMultiple from "../../BajaAltaMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import qrcode from "qrcode-js";
import moment from "moment";

function ReporteVentasArticulosMP() {
  const { user } = useContext(AuthContext);
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_UNIDADES_NEGOCIO = process.env.REACT_APP_URL_UNIDADES_NEGOCIO;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 15);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");

  const [marcas, setMarcas] = useState([]);
  const [selectedMarca, setSelectedMarca] = useState("");

  const [unidadesNegocio, setUnidadesNegocio] = useState([]);
  const [selectedUnidadNegocio, setSelectedUnidadNegocio] = useState("");

// Estados para resultados
// === Totales (sumas simples) ===
const [totals, setTotals] = useState({
  // Meli
  CantidadMeli: 0,
  PrecioPromedioBrutoMeliSum: 0,
  CostoMeliSum: 0,
  PrecioPromedioMeliSum: 0,

  // Amazon
  CantidadAmazon: 0,
  PrecioPromedioBrutoAmazonSum: 0,
  CostoAmazonSum: 0,
  PrecioPromedioAmazonSum: 0,

    // Walmart
  CantidadWalmart: 0,
  PrecioPromedioBrutoWalmartSum: 0,
  CostoWalmartSum: 0,
  PrecioPromedioWalmartSum: 0,

    // Coppel
  CantidadCoppel: 0,
  PrecioPromedioBrutoCoppelSum: 0,
  CostoCoppelSum: 0,
  PrecioPromedioCoppelSum: 0,

  // Generales
  TotalPrecioPromedioBruto: 0,
  TotalPrecioPromedioNeto: 0,
  TotalVentasBrutas: 0,
  TotalVentasNetas: 0,
});

// === Promedios ponderados ===
const [weightedAverages, setWeightedAverages] = useState({
  // Meli
  PrecioPromedioBrutoMeli: 0,
  CostoMeli: 0,
  PrecioPromedioMeli: 0,

  // Amazon
  PrecioPromedioBrutoAmazon: 0,
  CostoAmazon: 0,
  PrecioPromedioAmazon: 0,

    // Walmart
  PrecioPromedioBrutoWalmart: 0,
  CostoWalmart: 0,
  PrecioPromedioWalmart: 0,

    // Coppel
  PrecioPromedioBrutoCoppel: 0,
  CostoCoppel: 0,
  PrecioPromedioCoppel: 0,
});



  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [cargando, setCargando] = useState(true);
  const [fechaModificada, setFechaModificada] = useState(false);

  const [activo, setActivo] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    // timer: 5000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

    useEffect(() => {
  if (cargando) {
    Toast.fire({
      html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`, // Ícono de carga animado
      title: "Danos unos segundos....",
      customClass: {
        icon: 'animated-icon'
      }
    });
  }
  }, [cargando]);

  useEffect(() => {
      axios
    .get(`${URL_ARTICULOS_SURTIDOS}FechasVentaArticulosMP/${selectedFechaInicio}/${selectedFechaFin}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      // Ya viene agrupado y listo desde el backend
      setComments(response.data);

        setCargando(false);
        Toast.close();

      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
        .get(URL_MARCAS, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => {
          let allMarcas = response.data;
          setMarcas(allMarcas);
        })
        .catch((err) => {
          console.log(err);
        });

        axios
        .get(URL_UNIDADES_NEGOCIO, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => {
          let allUnidadesNegocio = response.data;
          setUnidadesNegocio(allUnidadesNegocio);
        })
        .catch((err) => {
          console.log(err);
        })

  }, []);

  function BuscaInfo(){
    setComments([])
    setCargando(true)
     axios
    .get(`${URL_ARTICULOS_SURTIDOS}FechasVentaArticulosMP/${selectedFechaInicio}/${selectedFechaFin}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      // Ya viene agrupado y listo desde el backend
      setComments(response.data);

      setCargando(false);
      setFechaModificada(false); // ✅ Regresa color azul
      Toast.close();
    })
    .catch((err) => {
      console.log(err);
    });
  }


  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        // (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        // (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == "" || selectedCliente == a.idCliente)&&
        (selectedMarca == "" || selectedMarca == a.Marca)&&
        (selectedUnidadNegocio == "" || selectedUnidadNegocio == a.UnidadNegocio)
      ) {
        return [
          a.SKU,
          a.nombre,
          a.marca,
          a.cliente,
          new Intl.NumberFormat("en-US").format(a.cantidad),
          new Intl.NumberFormat("en-US").format(a.entregado),
          new Intl.NumberFormat("en-US").format(a.porEntregar),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precioPromedio),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalPrecio),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 25, 25);
    doc.text(`Reporte Ventas Articulo MP`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "SKU",
          "Nombre",
          "Marca",
          "Cliente",
          "Cantidad",
          "Entregado",
          "Por Entregar",
          "Precio Promedio",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    // doc.save(`Ventas.pdf`);
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    // let agrupado = comments.reduce(function (groups, item) {
    //   const val = item["SKU"];
    //   groups[val] = groups[val] || {
    //     SKU: item.SKU,
    //     cantidad: 0,
    //   };
    //   groups[val].cantidad += item.cantidad;
    //   groups[val].SKU = item.SKU;
    //   groups[val].nombre = item.nombre;
    //   groups[val].marca = item.marca;
    //   groups[val].cliente = item.cliente;
    //   groups[val].entregado += item.entregado;
    //   groups[val].porEntregar += item.porEntregar;
    //   groups[val].precioPromedio = item.precioPromedio;
    //   return groups;
    // },[])

    // let computedComments = Object.values(agrupado);

    const dataExcel = comments.map((a) => {
      if (
        // (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        // (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == "" || selectedCliente == a.idCliente)&&
        (selectedMarca == "" || selectedMarca == a.Marca)&&
        (selectedUnidadNegocio == "" || selectedUnidadNegocio == a.UnidadNegocio)
      ) 
      {
        return {
          SKU: a.SKU,
          Articulo: a.Articulo,
          Marca: a.Marca,
          Linea: a.Linea,
          CantidadMeli: a.CantidadMeli,
          EntregadoCantidadMeli: a.EntregadoCantidadMeli,
          CantidadPendienteEntregarMeli: a.CantidadPendienteEntregarMeli,
          PrecioPromedioMeli: a.PrecioPromedioMeli,
          CostoMeli: a.CostoMeli,
          PrecioPromedioMeli: a.PrecioPromedioMeli,
          MargenMeli: a.MargenMeli,
          CantidadAmazon: a.CantidadAmazon,
          EntregadoCantidadAmazon: a.EntregadoCantidadAmazon,
          CantidadPendienteEntregarAmazon: a.CantidadPendienteEntregarAmazon,
          PrecioPromedioBrutoAmazon: a.PrecioPromedioBrutoAmazon,
          CostoAmazon: a.CostoAmazon,
          PrecioPromedioAmazon: a.PrecioPromedioAmazon,
          MargenAmazon: a.MargenAmazon,

          CantidadWalmart: a.CantidadWalmart,
          EntregadoCantidadWalmart: a.EntregadoCantidadWalmart,
          CantidadPendienteEntregarWalmart: a.CantidadPendienteEntregarWalmart,
          PrecioPromedioWalmart: a.PrecioPromedioWalmart,
          CostoWalmart: a.CostoWalmart,
          PrecioPromedioWalmart: a.PrecioPromedioWalmart,
          MargenWalmart: a.MargenWalmart,


          CantidadCoppel: a.CantidadCoppel,
          EntregadoCantidadCoppel: a.EntregadoCantidadCoppel,
          CantidadPendienteEntregarCoppel: a.CantidadPendienteEntregarCoppel,
          PrecioPromedioCoppel: a.PrecioPromedioCoppel,
          CostoCoppel: a.CostoCoppel,
          PrecioPromedioCoppel: a.PrecioPromedioCoppel,
          MargenCoppel: a.MargenCoppel,


          TotalPrecioPromedioBruto: a.TotalPrecioPromedioBruto,
          TotalPrecioPromedioNeto: a.TotalPrecioPromedioNeto,
          MargenBruto: a.MargenBruto,
          TotalVentasBrutas: a.TotalVentasBrutas,
          TotalVentasNetas: a.TotalVentasNetas,
          PrecioPromedioBrutoMeli: a.PrecioPromedioBrutoMeli,
          PrecioPromedioBrutoAmazon: a.PrecioPromedioBrutoAmazon,
          PrecioPromedioBrutoWalmart: a.PrecioPromedioBrutoWalmart,
          PrecioPromedioBrutoCoppel: a.PrecioPromedioBrutoCoppel,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ReporteVentasArticulosMP";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ReporteVentasArticulosMP",
        sheetFilter: [
          "SKU",
          "Articulo",
          "Marca",
          "Linea",
          "CantidadMeli",
          "EntregadoCantidadMeli",
          "CantidadPendienteEntregarMeli",
          "PrecioPromedioBrutoMeli",
          "CostoMeli",
          "PrecioPromedioMeli",
          "MargenMeli",
          "CantidadAmazon",
          "EntregadoCantidadAmazon",
          "CantidadPendienteEntregarAmazon",
          "PrecioPromedioBrutoAmazon",
          "CostoAmazon",
          "PrecioPromedioAmazon",
          "MargenAmazon",


          "CantidadWalmart",
          "EntregadoCantidadWalmart",
          "CantidadPendienteEntregarWalmart",
          "PrecioPromedioBrutoWalmart",
          "CostoWalmart",
          "PrecioPromedioWalmart",
          "MargenWalmart",


          "CantidadCoppel",
          "EntregadoCantidadCoppel",
          "CantidadPendienteEntregarCoppel",
          "PrecioPromedioBrutoCoppel",
          "CostoCoppel",
          "PrecioPromedioCoppel",
          "MargenCoppel",


          "TotalPrecioPromedioBruto",
          "TotalPrecioPromedioNeto",
          "MargenBruto",
          "TotalVentasBrutas",
          "TotalVentasNetas",
        ],
        sheetHeader: [
          "SKU",
          "Articulo",
          "Marca",
          "Linea",
          "CantidadMeli",
          "EntregadoCantidadMeli",
          "CantidadPendienteEntregarMeli",
          "PrecioPromedioBrutoMeli",
          "CostoMeli",
          "PrecioPromedioMeli",
          "MargenMeli",
          "CantidadAmazon",
          "EntregadoCantidadAmazon",
          "CantidadPendienteEntregarAmazon",
          "PrecioPromedioBrutoAmazon",
          "CostoAmazon",
          "PrecioPromedioAmazon",
          "MargenAmazon",


          "CantidadWalmart",
          "EntregadoCantidadWalmart",
          "CantidadPendienteEntregarWalmart",
          "PrecioPromedioBrutoWalmart",
          "CostoWalmart",
          "PrecioPromedioWalmart",
          "MargenWalmart",


          "CantidadCoppel",
          "EntregadoCantidadCoppel",
          "CantidadPendienteEntregarCoppel",
          "PrecioPromedioBrutoCoppel",
          "CostoCoppel",
          "PrecioPromedioCoppel",
          "MargenCoppel",


          "TotalPrecioPromedioBruto",
          "TotalPrecioPromedioNeto",
          "MargenBruto",
          "TotalVentasBrutas",
          "TotalVentasNetas",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        // (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        // (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == "" || selectedCliente == a.idCliente)&&
        (selectedMarca == "" || selectedMarca == a.Marca)&&
        (selectedUnidadNegocio == "" || selectedUnidadNegocio == a.UnidadNegocio)
      ) {
        return [
          a.SKU,
          a.nombre,
          a.marca,
          a.cliente,
          new Intl.NumberFormat("en-US").format(a.cantidad),
          new Intl.NumberFormat("en-US").format(a.entregado),
          new Intl.NumberFormat("en-US").format(a.porEntregar),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precioPromedio),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalPrecio),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 25, 25);
    doc.text(`Reporte Ventas Articulo MP`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "SKU",
          "Nombre",
          "Marca",
          "Cliente",
          "Cantidad",
          "Entregado",
          "Por Entregar",
          "Precio Promedio",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Reporte Ventas Articulo MP",
          email: mailTo,
          fileName: "ReporteVentasArticulosMP.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el Reporte Ventas Articulo MP.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "SKU", field: "SKU", sortable: true },
    { name: "Nombre", field: "Articulo", sortable: true },
    { name: "Vendido Meli", field: "CantidadMeli", sortable: true },
    { name: "Precio Prom Bruto Meli", field: "PrecioPromedioBrutoMeli", sortable: true },
    { name: "Costos Meli", field: "CostoMeli", sortable: true },
    { name: "Precio Prom Neto Meli", field: "PrecioPromedioMeli", sortable: true },
    { name: "Margen Meli", field: "MargenMeli", sortable: true },
    { name: "Vendido Amazon", field: "CantidadAmazon", sortable: true },
    { name: "Precio Prom Bruto Amazon", field: "PrecioPromedioBrutoAmazon", sortable: true },
    { name: "Costos Amazon", field: "CostoAmazon", sortable: true },
    { name: "Precio Prom Neto Amazon", field: "PrecioPromedioAmazon", sortable: true },
    { name: "Margen Amazon", field: "MargenAmazon", sortable: true },


    { name: "Vendido Walmart", field: "CantidadWalmart", sortable: true },
    { name: "Precio Prom Bruto Walmart", field: "PrecioPromedioBrutoWalmart", sortable: true },
    { name: "Costos Walmart", field: "CostoWalmart", sortable: true },
    { name: "Precio Prom Neto Walmart", field: "PrecioPromedioWalmart", sortable: true },
    { name: "Margen Walmart", field: "MargenWalmart", sortable: true },



    { name: "Vendido Coppel", field: "CantidadCoppel", sortable: true },
    { name: "Precio Prom Bruto Coppel", field: "PrecioPromedioBrutoCoppel", sortable: true },
    { name: "Costos Coppel", field: "CostoCoppel", sortable: true },
    { name: "Precio Prom Neto Coppel", field: "PrecioPromedioCoppel", sortable: true },
    { name: "Margen Coppel", field: "MargenCoppel", sortable: true },


    { name: "Total Precio Promedio Bruto", field: "TotalPrecioPromedioBruto", sortable: true },
    { name: "Total Precio Promedio Neto", field: "TotalPrecioPromedioNeto", sortable: true },
    { name: "Margen Bruto", field: "MargenBruto", sortable: true },
    { name: "Total Ventas Brutas", field: "TotalVentasBrutas", sortable: true },
    { name: "Total Ventas Netas", field: "TotalVentasNetas", sortable: true },

  ];


const commentsData = useMemo(() => {
  let computedComments = comments;

  if (search) {
    computedComments = computedComments.filter((comment) =>
      comment.SKU.toLowerCase().includes(search.toLowerCase()) ||
      comment.Articulo.toLowerCase().includes(search.toLowerCase()) ||

      comment.CantidadMeli?.toString().includes(search) ||
      comment.EntregadoCantidadMeli?.toString().includes(search) ||
      comment.CantidadPendienteEntregarMeli?.toString().includes(search) ||
      comment.PrecioPromedioBrutoMeli?.toString().includes(search) ||
      comment.CostoMeli?.toString().includes(search) ||
      comment.PrecioPromedioMeli?.toString().includes(search) ||
      comment.MargenMeli?.toString().includes(search) ||

      comment.CantidadAmazon?.toString().includes(search) ||
      comment.EntregadoCantidadAmazon?.toString().includes(search) ||
      comment.CantidadPendienteEntregarAmazon?.toString().includes(search) ||
      comment.PrecioPromedioBrutoAmazon?.toString().includes(search) ||
      comment.CostoAmazon?.toString().includes(search) ||
      comment.PrecioPromedioAmazon?.toString().includes(search) ||
      comment.MargenAmazon?.toString().includes(search) ||


            comment.CantidadWalmart?.toString().includes(search) ||
      comment.EntregadoCantidadWalmart?.toString().includes(search) ||
      comment.CantidadPendienteEntregarWalmart?.toString().includes(search) ||
      comment.PrecioPromedioBrutoWalmart?.toString().includes(search) ||
      comment.CostoWalmart?.toString().includes(search) ||
      comment.PrecioPromedioWalmart?.toString().includes(search) ||
      comment.MargenWalmart?.toString().includes(search) ||


            comment.CantidadCoppel?.toString().includes(search) ||
      comment.EntregadoCantidadCoppel?.toString().includes(search) ||
      comment.CantidadPendienteEntregarCoppel?.toString().includes(search) ||
      comment.PrecioPromedioBrutoCoppel?.toString().includes(search) ||
      comment.CostoCoppel?.toString().includes(search) ||
      comment.PrecioPromedioCoppel?.toString().includes(search) ||
      comment.MargenCoppel?.toString().includes(search) ||

      comment.TotalPrecioPromedioBruto?.toString().includes(search) ||
      comment.TotalPrecioPromedioNeto?.toString().includes(search) ||
      comment.MargenBruto?.toString().includes(search) ||
      comment.TotalVentasBrutas?.toString().includes(search) ||
      comment.TotalVentasNetas?.toString().includes(search)
    );
  }

  if (selectedCliente) {
    computedComments = computedComments.filter((e) =>
      e.idCliente?.includes(selectedCliente)
    );
  }
  if (selectedMarca) {
    computedComments = computedComments.filter((e) =>
      e.Marca?.includes(selectedMarca)
    );
  }
  if (selectedUnidadNegocio) {
    computedComments = computedComments.filter((e) =>
      e.UnidadNegocio?.includes(selectedUnidadNegocio)
    );
  }

  setTotalItems(computedComments.length);

  // Helpers
  const n = (x) => Number.parseFloat(x) || 0;
  const sumBy = (arr, key) => arr.reduce((t, a) => t + n(a[key]), 0);
  const wAvg = (arr, valueKey, weightKey) => {
    const w = sumBy(arr, weightKey);
    return w > 0
      ? arr.reduce((t, a) => t + n(a[valueKey]) * n(a[weightKey]), 0) / w
      : 0;
  };

  // === TOTALES ===
  const nextTotals = {
    // Meli
    CantidadMeli: sumBy(computedComments, "CantidadMeli"),
    PrecioPromedioBrutoMeliSum: sumBy(computedComments, "PrecioPromedioBrutoMeli"),
    CostoMeliSum: sumBy(computedComments, "CostoMeli"),
    PrecioPromedioMeliSum: sumBy(computedComments, "PrecioPromedioMeli"),

    // Amazon
    CantidadAmazon: sumBy(computedComments, "CantidadAmazon"),
    PrecioPromedioBrutoAmazonSum: sumBy(computedComments, "PrecioPromedioBrutoAmazon"),
    CostoAmazonSum: sumBy(computedComments, "CostoAmazon"),
    PrecioPromedioAmazonSum: sumBy(computedComments, "PrecioPromedioAmazon"),

        // Walmart
    CantidadWalmart: sumBy(computedComments, "CantidadWalmart"),
    PrecioPromedioBrutoWalmartSum: sumBy(computedComments, "PrecioPromedioBrutoWalmart"),
    CostoWalmartSum: sumBy(computedComments, "CostoWalmart"),
    PrecioPromedioWalmartSum: sumBy(computedComments, "PrecioPromedioWalmart"),

        // Coppel
    CantidadCoppel: sumBy(computedComments, "CantidadCoppel"),
    PrecioPromedioBrutoCoppelSum: sumBy(computedComments, "PrecioPromedioBrutoCoppel"),
    CostoCoppelSum: sumBy(computedComments, "CostoCoppel"),
    PrecioPromedioCoppelSum: sumBy(computedComments, "PrecioPromedioCoppel"),

    // Totales generales
    TotalPrecioPromedioBruto: sumBy(computedComments, "TotalPrecioPromedioBruto"),
    TotalPrecioPromedioNeto: sumBy(computedComments, "TotalPrecioPromedioNeto"),
    TotalVentasBrutas: sumBy(computedComments, "TotalVentasBrutas"),
    TotalVentasNetas: sumBy(computedComments, "TotalVentasNetas"),
  };
  setTotals(nextTotals);

  // === PROMEDIOS PONDERADOS ===
  const nextWAvgs = {
    PrecioPromedioBrutoMeli: wAvg(computedComments, "PrecioPromedioBrutoMeli", "CantidadMeli"),
    CostoMeli:               wAvg(computedComments, "CostoMeli", "CantidadMeli"),
    PrecioPromedioMeli:      wAvg(computedComments, "PrecioPromedioMeli", "CantidadMeli"),

    PrecioPromedioBrutoAmazon: wAvg(computedComments, "PrecioPromedioBrutoAmazon", "CantidadAmazon"),
    CostoAmazon:               wAvg(computedComments, "CostoAmazon", "CantidadAmazon"),
    PrecioPromedioAmazon:      wAvg(computedComments, "PrecioPromedioAmazon", "CantidadAmazon"),

        PrecioPromedioBrutoWalmart: wAvg(computedComments, "PrecioPromedioBrutoWalmart", "CantidadWalmart"),
    CostoWalmart:               wAvg(computedComments, "CostoWalmart", "CantidadWalmart"),
    PrecioPromedioWalmart:      wAvg(computedComments, "PrecioPromedioWalmart", "CantidadWalmart"),

        PrecioPromedioBrutoCoppel: wAvg(computedComments, "PrecioPromedioBrutoCoppel", "CantidadCoppel"),
    CostoCoppel:               wAvg(computedComments, "CostoCoppel", "CantidadCoppel"),
    PrecioPromedioCoppel:      wAvg(computedComments, "PrecioPromedioCoppel", "CantidadCoppel"),
  };
  setWeightedAverages(nextWAvgs);


    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "CantidadMeli" &&
      sorting.field != "EntregadoCantidadMeli" &&
      sorting.field != "CantidadPendienteEntregarMeli" &&
      sorting.field != "PrecioPromedioBrutoMeli" &&
      sorting.field != "CostoMeli" &&
      sorting.field != "PrecioPromedioMeli" &&
      sorting.field != "MargenMeli" &&

      sorting.field != "CantidadAmazon" &&
      sorting.field != "EntregadoCantidadAmazon" &&
      sorting.field != "CantidadPendienteEntregarAmazon" &&
      sorting.field != "PrecioPromedioBrutoAmazon" &&
      sorting.field != "CostoAmazon" &&
      sorting.field != "PrecioPromedioAmazon" &&
      sorting.field != "MargenAmazon" &&

            sorting.field != "CantidadWalmart" &&
      sorting.field != "EntregadoCantidadWalmart" &&
      sorting.field != "CantidadPendienteEntregarWalmart" &&
      sorting.field != "PrecioPromedioBrutoWalmart" &&
      sorting.field != "CostoWalmart" &&
      sorting.field != "PrecioPromedioWalmart" &&
      sorting.field != "MargenWalmart" &&


            sorting.field != "CantidadCoppel" &&
      sorting.field != "EntregadoCantidadCoppel" &&
      sorting.field != "CantidadPendienteEntregarCoppel" &&
      sorting.field != "PrecioPromedioBrutoCoppel" &&
      sorting.field != "CostoCoppel" &&
      sorting.field != "PrecioPromedioCoppel" &&
      sorting.field != "MargenCoppel" &&

      sorting.field != "TotalPrecioPromedioBruto" &&
      sorting.field != "TotalPrecioPromedioNeto" &&
      sorting.field != "MargenBruto" &&
      sorting.field != "TotalVentasBrutas" &&
      sorting.field != "TotalVentasNetas"

    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (
        sorting.field == "CantidadMeli" ||
        sorting.field == "EntregadoCantidadMeli" ||
        sorting.field == "CantidadPendienteEntregarMeli" ||
        sorting.field == "PrecioPromedioBrutoMeli" ||
        sorting.field == "CostoMeli" ||
        sorting.field == "PrecioPromedioMeli" ||
        sorting.field == "MargenMeli" ||

        sorting.field == "CantidadAmazon" ||
        sorting.field == "EntregadoCantidadAmazon" ||
        sorting.field == "CantidadPendienteEntregarAmazon" ||
        sorting.field == "PrecioPromedioBrutoAmazon" ||
        sorting.field == "CostoAmazon" ||
        sorting.field == "PrecioPromedioAmazon" ||
        sorting.field == "MargenAmazon" ||

                sorting.field == "CantidadWalmart" ||
        sorting.field == "EntregadoCantidadWalmart" ||
        sorting.field == "CantidadPendienteEntregarWalmart" ||
        sorting.field == "PrecioPromedioBrutoWalmart" ||
        sorting.field == "CostoWalmart" ||
        sorting.field == "PrecioPromedioWalmart" ||
        sorting.field == "MargenWalmart" ||


                sorting.field == "CantidadCoppel" ||
        sorting.field == "EntregadoCantidadCoppel" ||
        sorting.field == "CantidadPendienteEntregarCoppel" ||
        sorting.field == "PrecioPromedioBrutoCoppel" ||
        sorting.field == "CostoCoppel" ||
        sorting.field == "PrecioPromedioCoppel" ||
        sorting.field == "MargenCoppel" ||

        sorting.field == "TotalPrecioPromedioBruto" ||
        sorting.field == "TotalPrecioPromedioNeto" ||
        sorting.field == "MargenBruto" ||
        sorting.field == "TotalVentasBrutas" ||
        sorting.field == "TotalVentasNetas"

      )
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (
        sorting.field == "CantidadMeli" ||
        sorting.field == "EntregadoCantidadMeli" ||
        sorting.field == "CantidadPendienteEntregarMeli" ||
        sorting.field == "PrecioPromedioBrutoMeli" ||
        sorting.field == "CostoMeli" ||
        sorting.field == "PrecioPromedioMeli" ||
        sorting.field == "MargenMeli" ||

        sorting.field == "CantidadAmazon" ||
        sorting.field == "EntregadoCantidadAmazon" ||
        sorting.field == "CantidadPendienteEntregarAmazon" ||
        sorting.field == "PrecioPromedioBrutoAmazon" ||
        sorting.field == "CostoAmazon" ||
        sorting.field == "PrecioPromedioAmazon" ||
        sorting.field == "MargenAmazon" ||

                        sorting.field == "CantidadWalmart" ||
        sorting.field == "EntregadoCantidadWalmart" ||
        sorting.field == "CantidadPendienteEntregarWalmart" ||
        sorting.field == "PrecioPromedioBrutoWalmart" ||
        sorting.field == "CostoWalmart" ||
        sorting.field == "PrecioPromedioWalmart" ||
        sorting.field == "MargenWalmart" ||


                sorting.field == "CantidadCoppel" ||
        sorting.field == "EntregadoCantidadCoppel" ||
        sorting.field == "CantidadPendienteEntregarCoppel" ||
        sorting.field == "PrecioPromedioBrutoCoppel" ||
        sorting.field == "CostoCoppel" ||
        sorting.field == "PrecioPromedioCoppel" ||
        sorting.field == "MargenCoppel" ||

        sorting.field == "TotalPrecioPromedioBruto" ||
        sorting.field == "TotalPrecioPromedioNeto" ||
        sorting.field == "MargenBruto" ||
        sorting.field == "TotalVentasBrutas" ||
        sorting.field == "TotalVentasNetas"
      )
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedMarca,
    selectedFechaInicio,
    selectedFechaFin,
    selectedUnidadNegocio,
  ]);


  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_ventas ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuVentas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                {/* <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button> */}
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Reporte Ventas Articulo MP</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Reporte Ventas Articulo MP</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                  setFechaModificada(true);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                  setFechaModificada(true);
                }}
              />
            </Col>
            <Col md={1}>
            <h4></h4>
            <Button
              size="sm"
              className="btn"
              id="botonListado"
              onClick={BuscaInfo}
              color={fechaModificada ? "danger" : "info"}
            >
              Actualizar
            </Button>
          </Col>
            {/* <Col md={2}>
              <Label>Clientes</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCliente}
                onChange={(e) => {
                  setSelectedCliente(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {clientes
                  .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col> */}
            <Col md={2}>
              <Label>Marcas</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedMarca}
                onChange={(e) => {
                  setSelectedMarca(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {marcas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a.name}>{a.name}</option>;
                  })}
              </Input>
            </Col>
             <Col md={2}>
              <Label>Unidad Negocio</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedUnidadNegocio}
                onChange={(e) => {
                  setSelectedUnidadNegocio(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {unidadesNegocio
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a.name}>{a.name}</option>;
                  })}
              </Input>
            </Col>

            {/* <Col md={2}>
              <Label>Activo</Label>
              <Input
                bsSize="sm"
                type="select"
                value={activo}
                required
                onChange={(e) => {
                  setActivo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Activos</option>
                <option value="No">Inactivos</option>
              </Input>
            </Col> */}
          </Row>
          <br />
          <div className="table-wrapper">
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                  return (
                    <tr>
                      <td>{a.SKU}</td>
                      <td>{a.Articulo}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.CantidadMeli)}</td>
                      {/* <td>{new Intl.NumberFormat("en-US").format(a.EntregadoCantidadMeli)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.CantidadPendienteEntregarMeli)}</td> */}
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.PrecioPromedioBrutoMeli)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.CostoMeli)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.PrecioPromedioMeli)}</td>
                      <td style={a.MargenMeli < 15 ? { backgroundColor: "#ed8c8c" } : a.MargenMeli > 25 ? { backgroundColor: "#64e379" } : {}}>{new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(a.MargenMeli)} %</td>

                      <td>{new Intl.NumberFormat("en-US").format(a.CantidadAmazon)}</td>
                      {/* <td>{new Intl.NumberFormat("en-US").format(a.EntregadoCantidadAmazon)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.CantidadPendienteEntregarAmazon)}</td> */}
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.PrecioPromedioBrutoAmazon)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.CostoAmazon)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.PrecioPromedioAmazon)}</td>
                      <td style={a.MargenAmazon < 15 ? { backgroundColor: "#ed8c8c" } : a.MargenAmazon > 25 ? { backgroundColor: "#64e379" } : {}}>{new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(a.MargenAmazon)} %</td>
                    

<td>{new Intl.NumberFormat("en-US").format(a.CantidadWalmart)}</td>
                      {/* <td>{new Intl.NumberFormat("en-US").format(a.EntregadoCantidadWalmart)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.CantidadPendienteEntregarWalmart)}</td> */}
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.PrecioPromedioBrutoWalmart)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.CostoWalmart)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.PrecioPromedioWalmart)}</td>
                      <td style={a.MargenWalmart < 15 ? { backgroundColor: "#ed8c8c" } : a.MargenWalmart > 25 ? { backgroundColor: "#64e379" } : {}}>{new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(a.MargenWalmart)} %</td>



<td>{new Intl.NumberFormat("en-US").format(a.CantidadCoppel)}</td>
                      {/* <td>{new Intl.NumberFormat("en-US").format(a.EntregadoCantidadCoppel)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.CantidadPendienteEntregarCoppel)}</td> */}
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.PrecioPromedioBrutoCoppel)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.CostoCoppel)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.PrecioPromedioCoppel)}</td>
                      <td style={a.MargenCoppel < 15 ? { backgroundColor: "#ed8c8c" } : a.MargenCoppel > 25 ? { backgroundColor: "#64e379" } : {}}>{new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(a.MargenCoppel)} %</td>


                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.TotalPrecioPromedioBruto)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.TotalPrecioPromedioNeto)}</td>
                      <td style={a.MargenBruto < 15 ? { backgroundColor: "#ed8c8c" } : a.MargenBruto > 25 ? { backgroundColor: "#64e379" } : {}}>{new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(a.MargenBruto)} %</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.TotalVentasBrutas)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.TotalVentasNetas)}</td>
                    </tr>
                  );
              })}
{/* TOTALES */}
<tr>
  <td></td>
  <td className="negrita">TOTALES</td>

  {/* Cantidades y totales Meli */}
  <td className="negrita">
    {new Intl.NumberFormat("en-US").format(totals.CantidadMeli)}
  </td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(totals.PrecioPromedioBrutoMeliSum)}
  </td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(totals.CostoMeliSum)}
  </td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(totals.PrecioPromedioMeliSum)}
  </td>
  <td></td>

  {/* Cantidades y totales Amazon */}
  <td className="negrita">
    {new Intl.NumberFormat("en-US").format(totals.CantidadAmazon)}
  </td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(totals.PrecioPromedioBrutoAmazonSum)}
  </td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(totals.CostoAmazonSum)}
  </td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(totals.PrecioPromedioAmazonSum)}
  </td>
  <td></td>

    {/* Cantidades y totales Walmart */}
  <td className="negrita">
    {new Intl.NumberFormat("en-US").format(totals.CantidadWalmart)}
  </td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(totals.PrecioPromedioBrutoWalmartSum)}
  </td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(totals.CostoWalmartSum)}
  </td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(totals.PrecioPromedioWalmartSum)}
  </td>
  <td></td>

    {/* Cantidades y totales Coppel */}
  <td className="negrita">
    {new Intl.NumberFormat("en-US").format(totals.CantidadCoppel)}
  </td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(totals.PrecioPromedioBrutoCoppelSum)}
  </td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(totals.CostoCoppelSum)}
  </td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(totals.PrecioPromedioCoppelSum)}
  </td>
  <td></td>

  {/* Totales generales */}
  <td className="negrita">
    {new Intl.NumberFormat("en-US").format(totals.TotalPrecioPromedioBruto)}
  </td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US").format(totals.TotalPrecioPromedioNeto)}
  </td>
  <td></td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US").format(totals.TotalVentasBrutas)}
  </td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US").format(totals.TotalVentasNetas)}
  </td>
</tr>

{/* PROMEDIOS (ponderados por cantidad) */}
<tr>
  <td></td>
  <td className="negrita">PROMEDIOS</td>
  <td></td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(weightedAverages.PrecioPromedioBrutoMeli)}
  </td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(weightedAverages.CostoMeli)}
  </td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(weightedAverages.PrecioPromedioMeli)}
  </td>
  <td></td>
  <td></td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(weightedAverages.PrecioPromedioBrutoAmazon)}
  </td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(weightedAverages.CostoAmazon)}
  </td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(weightedAverages.PrecioPromedioAmazon)}
  </td>
  <td></td>
  <td></td>

  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(weightedAverages.PrecioPromedioBrutoWalmart)}
  </td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(weightedAverages.CostoWalmart)}
  </td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(weightedAverages.PrecioPromedioWalmart)}
  </td>
  <td></td>
  <td></td>

  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(weightedAverages.PrecioPromedioBrutoCoppel)}
  </td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(weightedAverages.CostoCoppel)}
  </td>
  <td className="negrita">
    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 })
      .format(weightedAverages.PrecioPromedioCoppel)}
  </td>
  <td></td>
  <td></td>
  <td></td>
  <td></td>
  <td></td>
  <td></td>
</tr>


            </tbody>
          </Table>
          </div>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      {loader}
    </>
  );
}

export default ReporteVentasArticulosMP;
